import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/modules/auth/stores/authStore';
import { wmsRoutes } from '@/modules/wms/routes';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...wmsRoutes,
    { path: '/settings', name: 'settings', component: () => import('@/shared/ui/Einstellungen.vue'), meta: { requiresWmsAdmin: true } },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/shared/ui/NotFound.vue') },
  ],
});

router.beforeEach((to) => {
  if (!to.meta.requiresWmsAdmin) {
    return true;
  }

  const authStore = useAuthStore();
  return authStore.roles.includes('wms-admin') ? true : { name: 'home' };
});

// router.beforeEach((to, _from, next) => {
//   const publicPages = ['/login', '/logout'];
//   const authRequired = !publicPages.includes(to.path);

//   let loggedIn = false;

//   if (localStorage.getItem('wmsUser') || sessionStorage.getItem('wmsUser')) {
//     loggedIn = true;
//   }

//   if (authRequired && !loggedIn) {
//     return next('/login');
//   }

//   next();
// });

export default router;
